import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { MemberProfile, ProfileCommand } from '../domain/member-profile';

@Component({ selector: 'app-email-editor', imports: [FormsModule], templateUrl: './email-editor.component.html' })
export class EmailEditorComponent {
  @Input({ required: true }) member!: Readonly<MemberProfile>;
  @Input() busy = false;
  @Input() blocked = false;
  @Output() submitted = new EventEmitter<ProfileCommand>();
  @Output() cancel = new EventEmitter<void>();
  newEmail = '';
  submit(form: NgForm): void {
    if (form.invalid || form.pending || this.busy || this.blocked) return;
    this.submitted.emit({ kind: 'email', value: this.newEmail });
  }
}
